module.exports = __webpack_public_path__ + "static/img/azamiuma.6db26a1.jpg";